module.exports = __webpack_public_path__ + "img/729464691.a976340b.jpg";